import { useState } from 'react';
import { Select } from 'antd';
import { useListCounterpartiesQuery } from '../api/counterpartyApi';

export interface CounterpartyMultiSelectProps {
  value: string[];
  onChange: (ids: string[]) => void;
  placeholder?: string;
}

/** §12.3: фильтр списка по нескольким контрагентам сразу. Подписи выбранных берутся из полного
 *  списка, а не из результата поиска — иначе при наборе текста выбранные превращались бы в
 *  технические идентификаторы. */
export function CounterpartyMultiSelect({ value, onChange, placeholder = 'Контрагент' }: CounterpartyMultiSelectProps) {
  const [q, setQ] = useState('');
  const { data: all = [] } = useListCounterpartiesQuery();
  const { data: found = [], isFetching } = useListCounterpartiesQuery({ q: q || undefined });

  const selected = all.filter((c) => value.includes(c.id));
  const options = [...selected, ...found.filter((c) => !value.includes(c.id))].map((c) => ({ value: c.id, label: c.name }));

  return (
    <Select<string[]>
      size="small"
      mode="multiple"
      allowClear
      showSearch
      filterOption={false}
      maxTagCount="responsive"
      loading={isFetching}
      placeholder={placeholder}
      style={{ width: '100%' }}
      value={value}
      options={options}
      onSearch={setQ}
      onChange={(ids) => {
        setQ('');
        onChange(ids);
      }}
    />
  );
}
